import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

class SaleBill {

    //--------------------票据头相关---------------------------//

    //INTF-00471 获取分页、可搜索的销售票据列表
    async getAllBillSaleHeader(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBillApp/service.billsale.BillSaleProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get sale invoice in pages failed: INTF-00471", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00472 对新建的销售票据头进行保存
    createBillSaleHeader(val) {
        let body = val;
        return axios.post(`/myBillApp/service.billsale.BillSaleProvider/CreateOne`, body);
    }

    //INTF-00473 对已创建的销售票据头进行修改
    updateBillSaleHeader(val) {
        let body = val;
        return axios.post(`/myBillApp/service.billsale.BillSaleProvider/UpdateBillSaleHeader`, body);
    }

    //INTF-00474 对选中的销售票据，进行批量生失效设置
    updateBillSaleHeaderIsActive(ids, isActive) {
        let body = { id_arr: ids, if_actived: isActive };
        return axios.post(`/myBillApp/service.billsale.BillSaleProvider/UpdateActived`, body);
    }

    //INTF-00475 获取头详细信息
    getBillSaleHeaderById(id) {
        let body = { id: id };
        return axios.post(`/myBillApp/service.billsale.BillSaleProvider/FindOne`, body);
    }

    //INTF-00479 删除
    deleteBillSaleHeader(ids) {
        let body = { id_arr: ids };
        return axios.post(`/myBillApp/service.billsale.BillSaleProvider/Delete`, body);
    }


    //--------------------票据行相关---------------------------//

    //INTF-00476 在一个销售票据头下，获取所有行
    getBillSaleLineByHeaderId(headerId, route) {
        let body = { types: "object,object", values: [{ header_id: headerId }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.BillSaleHeaderProvider/FindBillSaleLineByHeaderId`, body);
    }

    //INTF-00477 在一个销售票据头下，修改销售票据明细行
    updateBillSaleLineByHeaderId(headerId, lineList, route) {
        let body = { types: "object,object", values: [{ header_id: headerId, infos: lineList }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.BillSaleHeaderProvider/UpdateBillSaleLineByHeaderId`, body);
    }


}
export default SaleBill;